import { BoxProps, Paper, styled } from "@mui/material";
import { pxToRem } from "../../utils/fontSizeUtility";

type CustomChatBlockTimestampPaperProps = BoxProps & {
  isUser: boolean;
};

export const ChatBlockTimestampPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "isUser",
})<CustomChatBlockTimestampPaperProps>(({ theme, isUser }) => ({
  color: theme.palette.text.disabled,
  fontSize: pxToRem(13),
  marginLeft: isUser ? "auto" : 0,
  marginRight: isUser ? 0 : "auto",
  paddingLeft: pxToRem(8),
  paddingBottom: pxToRem(8),
  width: "fit-content",
  boxShadow: "none",
  backgroundImage: "none",
})) as React.ComponentType<CustomChatBlockTimestampPaperProps>;
